export default __webpack_public_path__ + "fb6c59cc88b85301c5bbb890afc71593.png";